import Vue from 'vue';
import App from './NewApp.vue';
import store from './store';
import './plugins/filters';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
// import './plugins/style/main.scss';
// import VueFlags from '@growthbunker/vueflags';

// Vue.use(VueFlags, {
//   iconPath: 'flags/'
// });

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
